import type { AppInkFlyoutAnchorProps } from "./AppInkFlyoutAnchor.Props";

export const isAppInkFlyoutAnchorProps = (props: {
  type: string;
}): props is AppInkFlyoutAnchorProps => {
  return (props as AppInkFlyoutAnchorProps).type === "AppInkFlyoutAnchorProps";
};
